module.exports = __webpack_public_path__ + "media/games-8.f7b50b1f.mp4";